import BaseService from "./Base.Service";

class AlertsService extends BaseService {
	constructor() {
		const model = {
			text: { type: String, required: true },
			sharedWith: { type: String, required: true },
			sharedTeams: { type: String, required: true }
		};

		super("alerts", model);
	}

    async getListEmpDash() {
        try {
            const { data } = await this.conn.axios.get(`/alerts/get-list-dash-emp`);
            return data;
        } catch (err) {
            return this.sendError("Erros foram encontrados ao recuperar dados", false, err);
        }
    }

    // Imagem do comunicado: com S3 o back responde JSON { url } com o link assinado;
    // no disco local, o arquivo. Sem toast no erro: quem abre mostra o aviso no lugar.
    async getImage(id) {
        try {
            const { data } = await this.conn.axios({
                method: 'GET',
                url: `/alerts/${id}/image`,
                responseType: 'blob'
            });

            if (data && typeof data.type === 'string' && data.type.includes('application/json')) {
                return JSON.parse(await data.text());
            }

            return data;
        } catch (err) {
            return { error: true };
        }
    }
}

export default AlertsService;
